export const BASE_URL = "https://api.forex.themaxibot.com/";
export const REGISTER_URL = "register/";
export const LOGIN_URL = "login/";
export const BOT_URL = "bot/";
export const VERIFY_URL = "verify/";
export const LOGOUT_URL = "logout/";
export const NEW_PLATFORM_URL = "trade-profile/";
// export const BASE_URL = "http://127.0.0.1:8000/"
